import React, { Component } from 'react'
import './Stepper.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import StepperCardGeneral from './StepperCardGeneral';

export default class StepperFrame extends Component {

    constructor(props) {
        super();
        this.state = {
            pageNumber: 0,
            cards: props.cards
        }
    }

    render() {

        let stepBackButton = <FontAwesomeIcon icon={faChevronLeft} className="StepperArrow StepperArrowActive" id="leftStepperArrow" onClick={this.stepBack}/>
        let stepForwardButton = <FontAwesomeIcon icon={faChevronRight} className="StepperArrow StepperArrowActive" id="rightStepperArrow" onClick={this.stepForward}/>
        
        let mobileButtons = (
        <div className="MobileButtonsContainer">
            <FontAwesomeIcon icon={faChevronLeft} className="StepperArrowMobile StepperArrowActive" id="leftStepperArrow" onClick={this.stepBack}/>
            <FontAwesomeIcon icon={faChevronRight} className="StepperArrowMobile StepperArrowActive" id="rightStepperArrow" onClick={this.stepForward}/>
        </div>)

        if(this.state.pageNumber == 0 && this.state.pageNumber == Object.keys(this.state.cards).length-1) {
            stepBackButton = <section className="StepperArrow StepperArrowActive"/>;
            stepForwardButton = <section className="StepperArrow StepperArrowActive"/>;
            // mobileButtons = <section className="StepperArrow StepperArrowActive"/>;
        } else {
            if(this.state.pageNumber == 0) {
                stepBackButton = <FontAwesomeIcon icon={faChevronLeft} className="StepperArrow StepperArrowInactive" id="leftStepperArrow" onClick={this.stepBack}/>;
                mobileButtons = 
                    <div className="MobileButtonsContainer">
                        <FontAwesomeIcon icon={faChevronLeft} className="StepperArrowMobile StepperArrowInactive" id="leftStepperArrow" onClick={this.stepBack}/>
                        <FontAwesomeIcon icon={faChevronRight} className="StepperArrowMobile StepperArrowActive" id="rightStepperArrow" onClick={this.stepForward}/>
                    </div>
            }
            if(this.state.pageNumber == Object.keys(this.state.cards).length-1){
                stepForwardButton = <FontAwesomeIcon icon={faChevronRight} className="StepperArrow StepperArrowInactive" id="rightStepperArrow" onClick={this.stepForward}/>
                mobileButtons = 
                    <div className="MobileButtonsContainer">
                        <FontAwesomeIcon icon={faChevronLeft} className="StepperArrowMobile StepperArrowActive" id="leftStepperArrow" onClick={this.stepBack}/>
                        <FontAwesomeIcon icon={faChevronRight} className="StepperArrowMobile StepperArrowInactive" id="rightStepperArrow" onClick={this.stepForward}/>
                    </div>
            }
        }
        
        let row1 =
            <div id="StepperRowDiv">
            {this.state.cards[this.state.pageNumber].map( 
                (n, index) => (
                    
                    <StepperCardGeneral  border={index} picture={n.picture} name={n.name} position={n.position} company={n.company} logoW={n.logoW} logoH={n.logoH} logoM={n.logoM} posminH={n.posminH} />
                )
            )}
            </div>
    
  
        return (
            //need to build a mapper to loop through the cards list and do this automatically for an unset number of cards
            
            <div className="Container">
                <h1 className="StepperTitle">{this.props.stepperTitle}</h1>
                <div id="StepperFrameDiv" style={{"min-height": this.props.minh}}>
                    {mobileButtons}
                    {stepBackButton}
                    <div id="StepperCardsContainer">                
                        {row1}
                    </div>
                    {mobileButtons}
                    {stepForwardButton}
                </div>
            </div>
        )
    }

    stepBack = () => {
        console.log("Go back");
        if(this.state.pageNumber > 0)
            this.setState({pageNumber: this.state.pageNumber-1});
    }

    stepForward = () => {
        console.log("Go forward");
        if(this.state.pageNumber < Object.keys(this.state.cards).length-1)
            this.setState({pageNumber: this.state.pageNumber+1});
    }
}